import React, { useState, useEffect } from "react";
import "./Calendar.css";
import Navbar from "../../../Member/Navbar/Navbar";
import { Button, Row, Col, Container } from "react-bootstrap";
import fr from "date-fns/locale/fr";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
// pick a date util library
import DateFnsUtils from "@date-io/date-fns";
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Divider from "@material-ui/core/Divider";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";
import avatar from "../../image/avatar.png";
import ServiceRdv from "../../../Admin/RendezVous/ServiceRdv/ServiceRdv";
import moment from "moment";
const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: "100%",
    backgroundColor: theme.palette.background.paper,
  },
  inline: {
    display: "inline",
  },
}));
const Calendar = () => {
  const [date, changeDate] = useState(new Date());
  console.log(new Date());
  const [info, setInfo] = useState();
  const classes = useStyles();

  const GetDataRdv = () => {
    ServiceRdv.getRdvByAdmin(
      JSON.parse(sessionStorage.getItem("user")).id
    ).then((res) => {
      setInfo(
        res.data.filter(
          (item) =>
            moment(item.dateform).format("DD/MM/YYYY") ===
            moment(date).format("DD/MM/YYYY")
        )
      );
    });
  };

  useEffect(() => {
    GetDataRdv();
  }, [date]);
  console.log(info);
  console.log(date);

  console.log("this is info data", info);
  return (
    <>
      <Navbar />
      <Container>
        <div className="calendar">
          <div className="cardc">
            <h3
              style={{
                borderRadius: "0.25em",
                textAlign: "center",
                border: "1px solid purple",
                padding: "0.5em",
                marginTop: "10px",
              }}
            >
              Liste des patients
            </h3>
            <Row>
              <Col lg={5}>
                <MuiPickersUtilsProvider locale={fr} utils={DateFnsUtils}>
                  <DatePicker
                    autoOk
                    variant="static"
                    openTo="date"
                    format="dd/MM/yyyy"
                    autoOk
                    minDate={new Date()}
                    value={date}
                    onChange={changeDate}
                  />
                </MuiPickersUtilsProvider>
              </Col>

              <>
                {/* <span>{item.user.firstName}</span>
                    <span>{item.hour}</span></br> */}
                <Col lg={7}>
                  <div className="listPatient">
                    {info &&
                      info.map((item, index) => (
                        <div className="option">
                          <List key={index} className={classes.root}>
                            <Row>
                              <Col lg={10}>
                                <ListItem alignItems="flex-start">
                                  <ListItemAvatar>
                                    <Avatar alt="Cindy Baker" src={avatar} />
                                  </ListItemAvatar>
                                  <ListItemText
                                    primary={item.user.firstName}
                                    secondary={
                                      <React.Fragment>
                                        <b>Adress :</b>73 boulevard Mohammed V
                                        2∞Èt. Rabat
                                        <br />
                                        <b>Tel :</b> 0611164241
                                      </React.Fragment>
                                    }
                                  />
                                </ListItem>
                                {/* <span>{item.user.firstName}</span> */}
                              </Col>
                              <Col lg={2} style={{ display: "flex" }}>
                                <Button style={{ margin: "auto" }}>
                                  {item.hour}
                                </Button>
                              </Col>
                            </Row>
                            <Divider variant="inset" component="li" />
                          </List>
                        </div>
                      ))}
                  </div>
                </Col>
              </>
            </Row>
          </div>
        </div>
      </Container>
    </>
  );
};

export default Calendar;
